import { Box, IconButton, useTheme } from "@mui/material"
import { useContext } from "react"
import {colorModeContext , tokens} from "../../theme"

import InputBase from "@mui/material/InputBase"
import LightModeOutlinedIcon  from "@mui/icons-material/LightModeOutlined"
import DarkModeOutlinedIcon  from "@mui/icons-material/DarkModeOutlined"
import NotificationsOutlinedIcon  from "@mui/icons-material/NotificationsOutlined"
import SettingsOutlinedIcon  from "@mui/icons-material/SettingsOutlined"
import PersonOutlinedIcon  from "@mui/icons-material/PersonOutlined"
import SearchOutlinedIcon  from "@mui/icons-material/SearchOutlined"

import './header.css'

export default function Header(){
    const theme = useTheme()
    const colors = tokens(theme.palette.mode)
    const colorMode = useContext(colorModeContext)
    return (
        <Box 
            display="flex" 
            // width="450px" 
            // justifyContent="space-between" 
            p={2}
        >
            <Box display="flex" backgroundColor={colors.primary[400]} borderRadius="3px">
                <InputBase sx={{ml: 2 , flex: 1}} placeholder="search"/>
                <IconButton type="button" sx={{p:1}} >
                    <SearchOutlinedIcon />
                </IconButton>
            </Box>
            <Box 
                display="flex" 
                justifyContent="space-between"
                position="absolute"
                right={0}
            >
                <IconButton onClick={colorMode.toggleColorMode}>
                    {theme.palette.mode === "dark"?
                    ( <DarkModeOutlinedIcon/>)  :
                    (<LightModeOutlinedIcon/>  )
                }       
                </IconButton>
                <IconButton>
                    <NotificationsOutlinedIcon/>         
                </IconButton>
                <IconButton>
                    <SettingsOutlinedIcon/>         
                </IconButton>
                <IconButton>
                    <PersonOutlinedIcon/>         
                </IconButton>
            </Box>
        </Box>
    )
}  